export default {
  watch: {
    'model.ride_types'() {
      if (!this.model.ride_types) {
        return
      }
      this.rideTypes.forEach(({ value }) => {
        if (!this.model.ride_types.includes(value)) {
          this.$set(this.model.vehicles, value, [])
        }
      })
    },
  },
}
